import styled from 'styled-components'

export const Text = styled.p`
  font-size: 13px;
  margin: 0;
  text-align: right;
  color: ${({ theme }) => theme.colors.primary};
`
export const Label = styled.p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
`
export const Title = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
`
export const SubTitle = styled.h4`
  font-size: 16px;
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 400;

  max-width: 260px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
export const TableRowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`
export const TableColContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  text-transform: uppercase;
`
export const TableColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 20px;
  &:last-child {
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: 0 0 10px 10px;
  }
`
export const TableRowWrapper = styled.div`
  display: flex;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.borderColor};
  border-bottom: 2px solid ${({ theme }) => theme.colors.backgroundLite};
  border-radius: 10px 10px 0 0;
`
export const TableButtonWrapper = styled.div`
  display: flex;
  padding: 20px;
  gap: 20px;
  justify-content: center;
  width: 100%;

  & button {
    width: 100% !important;
  }
`

export const StatusContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Chip = styled.p`
  font-size: 13px;
  margin: 0 0 4px 0;
  width: fit-content;
  padding: 2px 18px;
  ${({ theme, customer_status_id }) => `
    ${
      customer_status_id === -1 &&
      `
      ;color: ${theme.colors.red};
      background-color: transparent;
      border: 1px solid ${theme.colors.red};
      border-radius: 8px;
    `
    }
    ${
      (customer_status_id === -2 || customer_status_id === 0 || customer_status_id === 4) &&
      `
      ;color: ${theme.colors.primary};
      background-color: transparent;
      border: 1px solid ${theme.colors.primary};
      border-radius: 8px;
    `
    }
    ${
      customer_status_id > 0 &&
      `
      ;color: ${theme.colors.brand};
      background-color: transparent;
      border: 1px solid ${theme.colors.brand};
      border-radius: 8px;
    `
    }
  `};
`
